import * as React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, getSelectedState, GridCellProps } from '@progress/kendo-react-grid';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
/*import '@progress/kendo-theme-bootstrap/dist/all.css';*/
import './UserManagement.css';
import UserList from './UserList';
import UserEditForm from './UserEditForm';
import UserCreateForm from './UserCreateForm';
import { getUserList, getInternalIdps, disableUserMaster } from '../../ApiUtils/ApiUtils';
import * as ConsoleStore from '../../store/Console';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../store';
import { push } from 'connected-react-router';
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { disableUser, deleteUser } from '../../ApiUtils/ApiUtils';
import { Row } from 'reactstrap';
import { UserProfileContext } from '../Console/ConsoleLayout';
import SupportTeam from '../Console/Dashboard/SupportTeam';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export interface UserEditDetails {
    firstName: string;
    lastName: string;
}

interface EditCommandCellProps extends GridCellProps {
    enterEdit: (item: UserEditDetails) => void;
    enabled: boolean;
    onClickDelete: (item: any) => void;
}

interface EnableCommandCellProps extends GridCellProps {
    enabled: boolean;
    onSwitchChange: (e: SwitchChangeEvent, itemData: any)=>void;
}

export const EditCommandCell = (props: EditCommandCellProps) => {
    return (
        <td style={{ textAlign: "center" }}>
            <button
                
                className="btn btn-primary-sm"
                onClick={() => props.enterEdit(props.dataItem)}
            >
                Edit
            </button>&nbsp;
            {(!props.enabled && <button className="btn btn-primary-sm delete" onClick={()=>props.onClickDelete(props.dataItem)}>
                Delete
            </button>)}
        </td>
    );
};

export const EnableCommandCell = (props: EnableCommandCellProps, enabled:boolean) => {
    return (
        <td style={{ textAlign: "center" }}>
            <Switch checked={props.dataItem.enabled} onChange={(e: SwitchChangeEvent) => { props.onSwitchChange(e,props.dataItem) }}/>
        </td>
    );
};

interface UserManagementDashboardState {
    createFormOpen: boolean;
    editFormOpen: boolean;
    editItem: any;
    companies: any[];
    currentCompany?: any;
    hasCompanyAccessRoles?: boolean;
    isAdmin: boolean;
    isLoading: boolean;
    isRoot: boolean;
    records: any[] | null;
    submitErrors: any[];
    displayDeleteUserDialog: boolean;
    deleteUserDialogItemData: any;
}

type UserManagementDashboardProps = { console: any } & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps;

class UserManagementDashboard extends React.Component<UserManagementDashboardProps, UserManagementDashboardState> {
    static contextType = UserProfileContext;
    public constructor(props: UserManagementDashboardProps) {
        super(props);
        this.state = {
            createFormOpen: false,
            editFormOpen: false,
            editItem: null,
            companies: [],
            records: null,
            submitErrors: [],
            isRoot: false,
            isAdmin: false,
            currentCompany: undefined,
            hasCompanyAccessRoles: !(this.props.console?.applicationsState.applications.find((o: { applicationFullName: string; }) => { return o.applicationFullName === "PortalAdmin@" })?.roles?.filter((r:string )=> { return r.startsWith("admin_company:") }).length == 0),
            isLoading: true,
            displayDeleteUserDialog: false,
            deleteUserDialogItemData: null
        };

        if (this.state.isRoot || this.state.hasCompanyAccessRoles) {
            getInternalIdps().then(response => {
                this.setState({ companies: response })
            });
        }
       
    }

    public componentDidUpdate = (prevProps: UserManagementDashboardProps, prevState: UserManagementDashboardState) => {
        if ((this.state.currentCompany && !prevState.currentCompany)||(this.state.currentCompany && prevState.currentCompany && (prevState.currentCompany.name !== this.state.currentCompany.name || prevState.currentCompany.name === this.state.currentCompany.name && !this.state.records)
            )) {
            getUserList(this.state.currentCompany.name).then(response => {
                this.setState({
                    records: JSON.parse(response),
                    isLoading: false
                });
            });
        }
    }
    componentDidMount = () => {

        if (!this.state.currentCompany && ( this.context.permissions.admin || this.context.permissions.root))
        {
            var loadedCompanies:any = [];
            
            getInternalIdps().then(response => {
                loadedCompanies = response;
                getUserList(this.context.company).then(response => {
                    var curCompany = loadedCompanies.find((c:any) => { return c.name == this.context.company });
                    this.props.consoleActions.setCurrentCompany(curCompany);
                    this.setState({
                        isAdmin: this.context.permissions.admin,
                        isRoot: this.context.permissions.root,
                        currentCompany: curCompany,
                        records: JSON.parse(response),
                        companies: loadedCompanies,
                        isLoading: false
                    });
                });
            });
        }
    }
    /*
    public static getDerivedStateFromProps = (props: UserManagementDashboardProps, state: UserManagementDashboardState): UserManagementDashboardState | null => {
        //Change in props
        if (!state.currentCompany && props.console?.userProfileState.userProfile.company) {
            return {
                ...state,
                currentCompany: state.companies.find((c) => {return c.name == props.console?.userProfileState.userProfile.company})
            } as UserManagementDashboardState;
        }
        return null;
    }*/

    public handleChange = (event: DropDownListChangeEvent) => {
        this.setState({ currentCompany: event.target.value, isLoading: true });
        this.props.consoleActions.setCurrentCompany(event.target.value);
        getUserList(event.target.value.name).then(response => {  
            this.setState({
                records: JSON.parse(response),
                isLoading: false
            });
        })
    };

    public handleCancelEdit = () => {
        this.setState({ editFormOpen: false, submitErrors: [] });
    }

    public handleCancelCreate = () => {
        this.toggleCreateDialog();
        this.setState({ submitErrors: [] });
    }

    public toggleCreateDialog = () => {
        this.setState({
            createFormOpen: !this.state.createFormOpen
        });
    };

    public enterEdit = (item: any) => {
        this.setState({ editItem: item , editFormOpen: true});
    }

    public UserEditCommandCell = (props: GridCellProps) => (
        <EditCommandCell {...props} enterEdit={this.enterEdit} onClickDelete={this.handleClickDelete} enabled={props.dataItem.enabled}/>
    );

    public handleClickDelete =  (pItemData: any) => {
        this.setState({
            displayDeleteUserDialog: true,
            deleteUserDialogItemData: pItemData
        })
        
    }
    public handleDeleteUserConfirmation = async () => {
        const data = {
            "Username":this.state.deleteUserDialogItemData.email,
            "id": this.state.deleteUserDialogItemData.id,
            "Realm": this.state.currentCompany.name
        };
        var result = await deleteUser(data).then(response => {
            if (this.state.currentCompany) {
                getUserList(this.state.currentCompany.name).then(response => {
                    this.setState({
                        displayDeleteUserDialog:false,
                        records: JSON.parse(response),
                        isLoading: false
                    });
                })
            }
        });
    }

    public handleDisableUser = async (pSwitchEvent: SwitchChangeEvent, pItemData: any) => {

        const data = {
            "Username":pItemData.username,
            "id": pItemData.id,
            "Realm": this.state.currentCompany.name,
            "enabled": pSwitchEvent.value
        };
        if (this.state.isRoot) {
            var result = await disableUserMaster(data).then(response => {
                if (this.state.currentCompany) {
                    getUserList(this.state.currentCompany.name).then(response => {
                        this.setState({
                            records: JSON.parse(response),
                            isLoading: false
                        });
                    })
                }
            });
        } else {
            var result = await disableUser(data).then(response => {
                if (this.state.currentCompany) {
                    getUserList(this.state.currentCompany.name).then(response => {
                        this.setState({
                            records: JSON.parse(response),
                            isLoading: false
                        });
                    })
                }
            });
        }

        
}

    public UserEnableCommandCell = (props: GridCellProps, pEnabled: boolean) => (
        <EnableCommandCell {...props} enabled={pEnabled} onSwitchChange={(e: SwitchChangeEvent) => { this.handleDisableUser(e, props.dataItem) }}/>
    );

    public handleFormClose = () => {
        this.setState({
            isLoading: true,
            editFormOpen: false,
            createFormOpen: false,
        }, () => {
            getUserList(this.state.currentCompany.name ?? '').then(response => {
                this.setState({
                    records: JSON.parse(response),
                    isLoading: false
                });
            });
        });
    }
    public closeDeleteUserDialog = () => {
        this.setState({displayDeleteUserDialog:false})
    }
    public render() {
        return (
            <> <div style={{margin:"3%"}}>
                <br /> <h3 style={{ display: "inline-block" }}>Users</h3> <span> {this.state.isLoading && <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />} </span>
                
                {(this.state.isRoot || this.state.hasCompanyAccessRoles) && (
                    <div style={{ width: "300px" }} >
                        <h6>Company:</h6>
                        <DropDownList
                            data={this.state.companies}
                            textField="name"
                            value={this.state.currentCompany}
                            onChange={this.handleChange}
                            style={{ width: "200px" }}
                        />
                        <br />
                    </div>
                    )
                }
                {(this.state.currentCompany && (
                    <div style={{display:(this.state.currentCompany?"block":"none")}}>
                        <Row className="d-flex flex-row-reverse m-2">
                          <Link className="btn btn-primary" to="/admin/dashboard-management" style={{ width: "auto",marginRight: "25px" }} >Manage Dashboard</Link>
                          <button className="btn btn-primary" onClick={this.toggleCreateDialog} style={{ width: "auto",marginRight: "25px" }} >New user</button>
                        </Row>
                        {this.state.records && <UserList enableCell={this.UserEnableCommandCell} editCell={this.UserEditCommandCell} records={this.state.records} companyName={this.state.currentCompany} />}
                        {this.state.editFormOpen && <UserEditForm item={this.state.editItem} cancelEdit={this.handleCancelEdit} submitErrors={this.state.submitErrors} isRoot={this.state.isRoot} isAdmin={this.state.isAdmin} currentCompany={this.state.currentCompany.name} handleFormClose={this.handleFormClose} />}
                        {this.state.createFormOpen && <UserCreateForm handleClose={this.handleCancelCreate} submitErrors={this.state.submitErrors} handleFormClose={this.handleFormClose} currentCompany={this.state.currentCompany.name} />}
                    </div>)
                )}
            </div>
                <div className="support-footer" style={{ width: "100%" }}>
                    <SupportTeam></SupportTeam>
                </div>
                <Dialog style={{display:(this.state.displayDeleteUserDialog ? 'flex':'none')}} title={"Please confirm"} onClose={() => this.closeDeleteUserDialog()}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        Do you really want to delete user { this.state.deleteUserDialogItemData?.email } ?
                    </p>
                    <DialogActionsBar>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => this.closeDeleteUserDialog()}>
                            No
                        </button>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={this.handleDeleteUserConfirmation}>
                            Yes
                        </button>
                    </DialogActionsBar>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserManagementDashboard));
